import { render, staticRenderFns } from "./PerimeterSymbology.vue?vue&type=template&id=c1bc3a30&scoped=true"
import script from "./PerimeterSymbology.vue?vue&type=script&lang=js"
export * from "./PerimeterSymbology.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1bc3a30",
  null
  
)

export default component.exports